import React from 'react';
import debounce from 'lodash/debounce';
import { Select } from 'antd';
import styles from './tag-select.module.sass';

class TagSelect extends React.Component {
  constructor(props) {
    super(props);
    this.search = debounce(this.search, 100);
  }

  state = {
    data: [],
    value: null,
  };

  search = (value) => {
    this.props.searchForTags(value);
  };

  handleSearch = (value) => {
    this.search(value);
  };

  handleChange = (value) => {
    this.setState({ value });
  };

  handleSelect = (value) => {
    this.props.onSelect(value);
    if (this.props.clearValue) {
      this.setState({ value: null });
    }
  };

  render() {
    const options = this.props.foundTags?.map((tag) => (
      <Select.Option key={tag.value}>
        {tag.label}
        {tag.isNew && ' (create new)'}
      </Select.Option>
    ));
    return (
      <Select
        className={styles.select}
        showSearch
        value={this.state.value || this.props.value}
        placeholder={this.state.value || 'Tag Name'}
        // defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        notFoundContent={null}
      >
        {options}
      </Select>
    );
  }
}

export default TagSelect;
